export default {"src":"/_next/static/media/speech-bubble-tail.22f7237f.svg","height":22,"width":22,"blurWidth":0,"blurHeight":0};